module.exports = __webpack_public_path__ + "img/640.7ad10121.jpg";